import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { UserService } from 'app/auth/service';
import { GlobalService } from 'app/global/global.service';
import { SigningStatusEnum } from 'app/main/signing-pages/enums/enum';
import { environment } from 'environments/environment';
import { delay, filter, of, Subject, Subscription, take, takeUntil } from 'rxjs';
import { User } from '../../contract-control/contract-control-interfaces/cc-activity.interface';
import { HelperService } from '../../edit-template/helper.service';
import { HttpActionState } from '../../users/userslisting/store/users-listing.reducers';
import { DocumentListingFacade } from '../store/document-listing.facade';
import { DocumentIndexDataService } from './document-index-data.service';
import { FieldData } from '../../edit-template/edit-template.dto';
import { FieldInfo } from 'app/interfaces/field-base';

@Component({
  selector: 'app-document-index-data-modal',
  templateUrl: './document-index-data-modal.component.html',
  styleUrl: './document-index-data-modal.component.scss'
})
export class DocumentIndexDataModalComponent implements OnInit, OnDestroy {

  @Input({required: true}) documentId: number;
  @ViewChild('docField', { static: false }) set content(content: NgSelectComponent) {
    if (content) {
      this.timeOutSubscription = of(null).
        pipe(
          takeUntil(this.destroy$),
          delay(0),
        ).subscribe(() => {
          this.docField = content;
        })
    }
  }

  private timeOutSubscription: Subscription;
  public currentUrl: string = environment.appUrl;
  private destroy$ = new Subject<void>();
  private docField: NgSelectComponent;
  public isOwnerEditable: boolean = false;
  public httpActionState = HttpActionState;
  public externalLoader: HttpActionState;
  public documentStatusEnum = SigningStatusEnum;
  public fieldInfo = FieldInfo;
  public documentFields: { key: string; value: FieldData; }[] = [];

  constructor(
    private _documentFacade$: DocumentListingFacade,
    public modalService: NgbModal,
    public _globalService$: GlobalService,
    public _recipientHelper$: HelperService,
    private _userService$: UserService,
    private _documentIndexDataService$: DocumentIndexDataService
  ) { }

  public checkObjectLength = Object.keys;
  public selectedOwner: number | null;
  public workSpaceUsers: User[] = [];

  public indexData$ = this._documentFacade$.documentIndexData$;
  public indexDataRequestState$ = this._documentFacade$.documentIndexDataRequestState$;

  ngOnInit(): void {
    this.fetchDocumentIndexData();
    this.fetchSubUsers();
  }



  fetchDocumentIndexData() {
    this._documentFacade$.documentIndexData(this.documentId);

    this.indexData$.pipe(
      filter(indexData => !!indexData),
      takeUntil(this.destroy$),
    ).subscribe({
      next: (indexData) => {
        this.externalLoader = HttpActionState.Done;
        const fieldDatas = this._globalService$.filterDuplicates(indexData?.template_fields_datas?.data);
        const entries = Object.entries(fieldDatas)
          .filter(entry => !!entry[1]);
        this.documentFields = entries.map(([key, value]) => ({ key, value: value as FieldData }));
      }
    });
  }


  fetchSubUsers() {
    this._userService$.getSubUsers(true).pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: User[]) => {
        this.workSpaceUsers = response;
      }
    });
  }



  showOwners() {
    this.isOwnerEditable = !this.isOwnerEditable;
    this.timeOutSubscription = of(null).
      pipe(
        delay(200),
        take(1)
      ).subscribe(() => {
        this.docField.open();
      });
  }


  changeOwner() {
    this.externalLoader = HttpActionState.Busy;
    this._documentIndexDataService$.updateDocumentOwner(this.documentId, this.selectedOwner).
      pipe(
        takeUntil(this.destroy$)
      ).subscribe({
        next: () => {
          this.selectedOwner = null;
          this.fetchDocumentIndexData();
          this._documentIndexDataService$.shouldRefreshParticipants$.next({ refreshParticipants: true });
        }
      });
  }



  closeModal() {
    this.modalService.dismissAll();
  }



  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timeOutSubscription) {
      this.timeOutSubscription.unsubscribe();
    }
  }
}
